import { defineComponent as d, computed as o, openBlock as l, createElementBlock as i, createElementVNode as t, toDisplayString as h, createCommentVNode as n, normalizeStyle as f, createStaticVNode as p } from "vue";
const _ = ["viewBox"], m = /* @__PURE__ */ t("mask", { id: "abd28fa1-8c17-4234-be00-a4c925b96ecb" }, [
  /* @__PURE__ */ t("circle", {
    cx: "256",
    cy: "256",
    r: "256",
    fill: "#fff"
  })
], -1), k = { mask: "url(#abd28fa1-8c17-4234-be00-a4c925b96ecb)" }, u = { key: 0 }, v = /* @__PURE__ */ p('<path fill="#d80027" d="m0 384 254.7-32.7L512 383.9V512H0z"></path><path fill="#0052b4" d="m0 256 255-27 257 27v128H0z"></path><path fill="#ffda44" d="M0 0h512v256H0z"></path><circle cx="256" cy="256" r="89" fill="#ffda44"></circle><path fill="#338af3" d="M256 311.6c-30.7 0-55.7-25-55.7-55.6v-33.4a55.7 55.7 0 0 1 111.4 0V256c0 30.6-25 55.6-55.7 55.6z"></path><path fill="#333" d="M345 122.4h-66.7a22.3 22.3 0 0 0-44.6 0H167a23 23 0 0 0 23 22.3h-.8c0 12.3 10 22.3 22.3 22.3 0 12.3 10 22.2 22.2 22.2h44.6c12.3 0 22.2-10 22.2-22.2 12.3 0 22.3-10 22.3-22.3h-.8a23 23 0 0 0 23-22.3z"></path>', 6), g = { fill: "none" }, b = ["r"], z = /* @__PURE__ */ d({
  __name: "ec",
  props: {
    flagName: {},
    strokeColor: { default: "#000" },
    strokeWidth: { default: 0 }
  },
  setup(s) {
    const e = s, a = o(() => 512 + 2 * e.strokeWidth), c = o(() => -e.strokeWidth), r = o(() => 256 + e.strokeWidth / 2);
    return (x, w) => (l(), i("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      class: "svg-circle-flags",
      viewBox: `${c.value} ${c.value} ${a.value} ${a.value}`
    }, [
      m,
      t("g", k, [
        e.flagName ? (l(), i("title", u, h(e.flagName), 1)) : n("", !0),
        v
      ]),
      t("g", g, [
        t("circle", {
          cx: "256",
          cy: "256",
          r: r.value,
          fill: "none",
          style: f({ stroke: e.strokeColor, strokeWidth: e.strokeWidth })
        }, null, 12, b)
      ])
    ], 8, _));
  }
});
export {
  z as default
};
//# sourceMappingURL=ec-1bbad3f0.js.map
